var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget px-1 px-md-3 py-1 py-md-2 mw-100"},[_c('bar-chart',{attrs:{"height":200,"width":280,"data":_vm.barChart(),"options":{
            legend: { display: true },
            position: 'top',
            layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
            responsive: true,
            maintainAspectRatio: false,

            scales: {
                xAxes: [
                    {
                        gridLines: {
                            display: false,
                        },
                        stacked: true,
                    } ],
                yAxes: [
                    {
                        gridLines: {
                            display: false,
                        },
                        stacked: true,
                    } ],
            },
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }